import { CoreQuery } from '@/common/services/core-query';
import { EntitiesList } from '@/common/models';
import { authorizeClient, httpClientCoreQuery } from '@/api/http-client';
import { DataRequestOptions, TablePaginatedData } from '@/common/components/table/v2/interfaces';

import { FluentFilterCollection, isNotEmpty, Operator } from '@/common/services';
import { Category } from '@/admin/topics/models';
import { CategoryApiFactory } from '@eloomi/eloomi-topics-persona-client/1.0';
import { UserApiFactory } from '@eloomi/eloomi-learning-persona-client/1.0';
import { extractAxiosData } from '@/common/services/extractAxiosData';

const userLearningApiFactory = authorizeClient(UserApiFactory);
// TODO remove and refactor usages
export function getCategories(options?: DataRequestOptions) {
    const q = new CoreQuery().entity([EntitiesList.TOPICS, EntitiesList.PERSONA, EntitiesList.CATEGORY]);
    if (options) {
        const filters = isNotEmpty(options.searchQuery)
            ? new FluentFilterCollection().where('name').filter(Operator.Contains, options.searchQuery!)
            : undefined;

        q.filters(filters).param({
            page: options.page,
            page_size: options.pageSize,
        });
    }
    return httpClientCoreQuery.get<TablePaginatedData<Category>>(q).then(({ data }) => data);
}

export function getUserCategories() {
    return userLearningApiFactory.getUserCategories().then(extractAxiosData);
}

// New version
const categoryApiClient = authorizeClient(CategoryApiFactory);

function getFilters(options?: DataRequestOptions) {
    if (!options?.searchQuery) return undefined;

    const filter = new FluentFilterCollection();
    filter.where('name').filter(Operator.Contains, options.searchQuery);

    return filter.build();
}

export function getCategoriesNew(options?: DataRequestOptions) {
    const filters = getFilters(options);

    return categoryApiClient.get(filters, undefined, options?.page, options?.pageSize).then(extractAxiosData);
}
